<template>
    <div class="game-mainstage noselect">
        <div :class="['tttField', fieldsize == 3 ? '' : fieldsize == 4 ? 'four': 'five']">
            <div :class="['tttnumber', closedCheck(number) ? 'closed' : '']" v-for="(number, numberIndex) in numbers" :key="number" @click="inputNumber(numberIndex)">
                <template v-if="!closedCheck(number)">
                    <div class="hitplayer hitplayer1" v-html="playerHit(0, numberIndex)"></div>
                    <div class="hitplayer hitplayer3" v-html="playerHit(2, numberIndex)"></div>
                    <div class="number">{{number == 25 ? "B" : number}}</div>
                    <div class="hitplayer hitplayer4" v-html="playerHit(3, numberIndex)"></div>
                    <div class="hitplayer hitplayer2" v-html="playerHit(1, numberIndex)"></div>
                </template>
                <template v-else>
                    <div class="number closed">{{closedCheckIcon(numberIndex)}}</div>
                </template>
            </div>
        </div>
        <div class="player-darts">
            <template v-if="inputNumbers.length == 0">
                <div class="game-player-dart game-player-dart1">
                    <div :class="['game-player-dart-throw',colorCheck(singlescores, 0)]" v-html="singlescore(1)"></div>
                </div>
                <div class="game-player-dart game-player-dart2">
                    <div :class="['game-player-dart-throw',colorCheck(singlescores, 1)]" v-html="singlescore(2)"></div>
                </div>
                <div class="game-player-dart game-player-dart3">
                    <div :class="['game-player-dart-throw',colorCheck(singlescores, 2)]" v-html="singlescore(3)"></div>
                </div>
            </template>
            <template v-else>
                <div class="send_button number success" @click="sendScoreArrayToNumpad()">
                    {{ __("games.send") }}
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'currentOnly'
    ],
    data() {
        return {
            playerIndex: 0,
            winner: false,
            loser: false,
            name: '',
            score: 0,
            fullscore_sum: 0,
            lastscore: 0,
            currentPlayer: false,
            startPlayer: false,
            singlescores: [],
            avg3: 0,
            avg1: 0,
            dartcount: 0,
            showCPUBar: false,
            legs: 0,
            sets: 0,
            maxlegs: 0,
            maxsets: 0,
            roundEnd: false,
            numbers: [],
            closedNumbers: [],
            players: [],
            scores: [],
            dartsfield: 4,
            fieldsize: 3,
            icons: ["X", "O", "A", "E"],
            inputNumbers: [],
        }
    },
    mounted() {
        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);
    },

    methods: {
        update(data) {
            if (data == null) return;
            this.inputNumbers = [];
            this.playerIndex = data.gameState.currentPlayerIndex;
            this.scores = data.gameState.scores;
            this.name = data.gameState.scores[this.playerIndex].name;
            this.score = data.gameState.scores[this.playerIndex].score;
            this.fullscore_sum = data.gameState.scores[this.playerIndex].fullscore_sum;
            this.lastscore = data.gameState.scores[this.playerIndex].lastscore;
            this.singlescores = data.gameState.scores[this.playerIndex].singlescores;
            this.currentPlayer = data.gameState.currentPlayer == this.playerId;
            this.startPlayer = data.gameState.throws.startPlayer == this.playerId;

            this.players = data.players;

            this.winner = data.gameState.winner == this.playerId;
            this.loser = data.gameState.winner && data.gameState.winner != this.playerId;

            this.dartsfield = data.gameState.dartsfield;

            if (data.gameState.numbers) {
                this.numbers = data.gameState.numbers;
                this.closedNumbers = data.gameState.closedNumbers;
            }
            if (data.gameState.fieldsize) {
                this.fieldsize = data.gameState.fieldsize;
            }

            if (data.gameState.scores[this.playerIndex].stats) {
                this.avg3 = data.gameState.scores[this.playerIndex].stats.avg3.toFixed(2);
                this.avg1 = data.gameState.scores[this.playerIndex].stats.avg1.toFixed(2);
                this.dartcount = data.gameState.scores[this.playerIndex].stats.dartcount;
            }

            //sets and legs
            if (data.setState) {
                this.legs = data.setState["legs_player" + (this.playerIndex + 1)];
                this.sets = data.setState["sets_player" + (this.playerIndex + 1)];
                this.maxsets = data.setState["max_sets"];
                this.maxlegs = data.setState["max_legs"];
            }

            //cpu bar update
            if (data.gameState && this.currentPlayer && data.gameState.currentUserType == "computer") {
                this.showCPUBar = true;
                var cpuplayer = data.gameState.scores[data.gameState.currentPlayerIndex];
                document.documentElement.style.setProperty('--cputimer', cpuplayer.nextplayertime + 's');
            } else {
                this.showCPUBar = false;
            }

            //reset fullscore sum on next player in 1 player game
            if (data.action == "nextPlayer" && data.gameState.scores.length == 1) {
                this.fullscore_sum = 0;
                this.singlescores = [];
            }

            //show hide end of round overlay
            this.roundEnd = data.action == "playerInputSingle" && this.singlescores && this.singlescores.length == 3 && this.currentPlayer;
        },
        singlescore(num) {
            if (this.singlescores) {
                if (this.singlescores[num - 1] && this.singlescores[num - 1]['str'] !== undefined)
                    return this.singlescores[num - 1]['str'];
                else if (this.singlescores[num - 1])
                    return this.singlescores[num - 1];
                else
                    return '<img src="/images/dart.png">';
            }
            return '<img src="/images/dart.png">';
        },
        colorCheck(data, number) {
            if (!data) return;
            if (data[number] !== undefined && data[number].success) return "success";
            if (data[number] !== undefined && data[number].missed === false) return "success";
            if (data[number] !== undefined && data[number].missed) return "miss";
            if (data[number] === undefined) return "open";
        },
        closedCheck(number) {
            return this.closedNumbers.includes(number) ? 'closed' : '';
        },
        closedCheckIcon(numberIndex) {
            for (let i = 0; i < this.scores.length; i++) {
                const score = this.scores[i];
                let currentInput = i == this.playerIndex ? this.countInputNumbers(numberIndex) : 0;
                if (score.hits[numberIndex] + currentInput >=this.dartsfield) return this.icons[i];
            }
            return "";
        },
        playerHit(playerIndex, numberIndex) {
            var returnString = "";
            if (playerIndex >= this.scores.length) return returnString;
            for (let i = 0; i < this.scores[playerIndex].hits[numberIndex]; i++) {
                returnString += this.icons[playerIndex]
            }
            if (playerIndex == this.playerIndex)
                for (let i = 0; i < this.countInputNumbers(numberIndex); i++) {
                    returnString += this.icons[playerIndex]
                }
            return returnString
        },
        inputNumber(numberIndex) {
            var number = this.numbers[numberIndex];
            this.inputNumbers.push(number);
            if (this.countInputNumbers(numberIndex) + this.scores[this.playerIndex].hits[numberIndex] == this.dartsfield) {
                this.closedNumbers.push(this.numbers[numberIndex]);
            }
            if (this.countInputNumbers(numberIndex) + this.scores[this.playerIndex].hits[numberIndex] > this.dartsfield) {
                this.closedNumbers.splice(this.closedNumbers.indexOf(this.numbers[numberIndex]), 1);
                for (let i = this.inputNumbers.length -1; i >= 0 ; i--) {
                    const element = this.inputNumbers[i];
                    if (element == this.numbers[numberIndex]) this.inputNumbers.splice(i, 1);
                }
            }
        },
        countInputNumbers(numberIndex) {
            var returnNumber = 0;
            this.inputNumbers.forEach(num => {
                if (num == this.numbers[numberIndex]) {
                    returnNumber ++;
                }
            });
            return returnNumber;
        },
        sendScoreArrayToNumpad() {
            this.$root.$emit('score-array-to-numpad', this.inputNumbers);
        }
    }

}
</script>

<style scoped>
    .game-mainstage {
        min-height: 60vh;
    }

    .player-darts {
        grid-area: player-darts;
        display: grid;
        grid-template-areas: "dart1 dart2 dart3";
        grid-template-columns: 1fr 1fr 1fr;
    }

    .tttnumber {
        cursor: pointer;
    }

    .send_button {
        display: block;
        width: 100%;
        background: #009948;
        grid-column-start: 1;
        grid-column-end: 4;
        text-align: center;
        font-size: 2vw;
        color: #fff;
        cursor: pointer;
    }
</style>
